import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-alert-ring',
  templateUrl: 'alert-ring.component.html'
})
export class AlertRingComponent {
  constructor() {}
}
